import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Gateway } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  deviceId: number
  options?: Omit<UseQueryOptions<unknown, Error, Gateway>, 'queryKey' | 'queryFn'>
}

export const useGatewayRequest = ({ deviceId, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Gateway>(
    [Entities.Gateway, deviceId],
    async () => {
      const { data } = await api.v1AdminGatewaysGatewayIdGet(deviceId)

      return data
    },
    {
      ...options
    }
  )
}
